module.exports = __webpack_public_path__ + "img/taipingyang.9428e206.png";